const PoweredBy = () => (
  <div className="fixed right-0 bottom-0 z-10">
    <a href="https://nextlessjs.com" target="_blank" rel="noopener noreferrer">
      <div className="py-2 px-3 font-semibold text-gray-100 bg-gray-900 rounded-md">
        <span className="text-gray-500">Powered By</span> Nextless.js
      </div>
    </a>
  </div>
);

export { PoweredBy };
